import { closeAccessoryDrawerResolver } from './closeAccessoryDrawerResolver'
import { showAccessoryDrawerResolver } from './showAccessoryDrawerResolver'
import { type MutationResolvers } from '../../../../generated/graphql'

export const accessoryDrawerMutations: MutationResolvers = {
    closeAccessoryDrawer: closeAccessoryDrawerResolver,
    showAccessoryDrawer: showAccessoryDrawerResolver,
}
